<template>
  <div class="page-preach">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/ah`"
          >招工招生</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="`${$subsitePrefix}/ah/hiring`"
          >企业招聘</el-breadcrumb-item
        >
        <el-breadcrumb-item>线上宣讲会</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content" v-loading="loading">
        <preach-card
          v-for="item in preachList"
          :data="item"
          :key="item.id"
        ></preach-card>
      </div>
      <el-pagination
        v-if="total > pageSize"
        class="g-pagination"
        background
        layout="prev, pager, next"
        :current-page="pageIndex"
        :page-size="pageSize"
        :total="total"
        @current-change="handleIndexChange"
      >
        ></el-pagination
      >
    </div>
  </div>
</template>

<script>
import { getData } from "api/app";
import Card from "../components/PreachCard";
import { mapState } from "vuex";
export default {
  data() {
    return {
      preachList: [],
      total: 0,
      pageSize: 6,
      pageIndex: 1,
      loading: false
    };
  },
  computed: {
    ...mapState("college", ["collegeData", "currentMajor"])
  },
  created() {
    this.init();
  },
  components: {
    [Card.name]: Card
  },
  methods: {
    handleIndexChange(index) {
      this.pageIndex = index;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      let params = [
        {
          Key: "College",
          Value: this.collegeData.college.Id,
          CompareType: "EqualTo"
        }
      ];
      var queryParams = {
        name: "Preach",
        index: this.pageIndex,
        size: this.pageSize ?? 3,
        params: params
      };
      getData(queryParams)
        .then(res => {
          const arr = [];
          res.Data.forEach(item => {
            arr.push({
              id: item.Id,
              pic: item.Picture,
              name: item.Headline,
              view: item.ViewCount ?? 0,
              time: item.StartTime,
              link: item.LiveUrl
            });
          });
          this.loading = false;
          this.preachList = arr || [];
          this.total = res.TotalCount;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    init() {
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-preach {
  background: #f6f6f9;
  padding-bottom: 40px;
  .content {
    display: flex;
    flex-wrap: wrap;
  }
  .g-pagination {
    margin-top: 24px;
  }
}
</style>
